import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoginService } from '~login/services/login.service';
import { environment } from '~environment';

const baseUrl: string = environment.serverBaseUrl;
const blacklist: string[] = [environment.serverBaseUrl + 'auth/login'];

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const auth = inject(LoginService);
    const token: string | null = auth.getToken();
    const wrappedRequest: HttpRequest<unknown> = wrapRequest(req, token);
    return next(wrappedRequest);
};

function wrapRequest(request: HttpRequest<unknown>, token: string | null): HttpRequest<unknown> {
    if (token == null || !request.url.startsWith(baseUrl) || blacklist.includes(request.url)) {
        return request;
    }

    return request.clone({
        setHeaders: {
            Authorization: `Bearer ${token}`,
        },
    });
}
